<template>
    <Card class="card">
        <template #title>
            Web Accessibility Non-conformance Statement
            <Button icon="pi pi-times" class="p-button-rounded p-button-secondary p-button-text"
                style="position:fixed;right:10px" @click="close()" />
        </template>
        <template #content>
            <div style="text-align: left;">
                <p>We are committed to ensuring that our website conforms to the World Wide Web Consortium (W3C)
                    Web Content
                    Accessibility Guidelines (WCAG) 2.1 Level AA requirements to the maximum extent possible.
                    However, as our
                    website contains colour digital maps, huge volume of map image data with dynamic and
                    complicated spatially
                    interrelated contents and advanced map related functions, it is impossible to incorporate
                    all Level AA
                    accessibility requirements such as to convey the map information without relying on colours,
                    provide text
                    descriptions for all map images and control map functions simply using keyboards.</p>
            </div>
        </template>
    </Card>
</template>

<script>

export default {
    name: 'GuideView',
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {
        close() {
            this.$router.replace({ path: '/' });
        }
    },
    mounted() {
    }
}
</script>

<style scoped>
.card {
    width: 50vw;
    position: absolute;
    transform: translate(60%, 10%);
}

.t-a-left {
    text-align: left;
}

.icon-container {
    background-color: #00632c;
    color: white;
    height: 3.5rem;
    width: 3.5rem;
    justify-content: center;
    display: flex;
}

.image-icon {
    width: 25px;
    padding: 0.5rem 0;
}

.pi-icon {
    margin-top: 10px;
}

.icon-with-label {
    display: flex;
    margin-bottom: 10px;
}

.icon-with-label p {
    margin-left: 10px;
}

.contentPanel {
    width: 100%;
    height: calc(100vh - 320px - 4rem);
    text-align: left;
}
</style>